import script from "./StepPricing.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPricing.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import AmountField from "@/components/neue/wizard/AmountField.vue";
import HelpHint from "@/components/neue/wizard/HelpHint.vue";
import HighlightedText from "@/components/neue/wizard/HighlightedText.js";
import SelectionCard from "@/components/neue/wizard/SelectionCard.vue";
import SelectionGroup from "@/components/neue/wizard/SelectionGroup.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { AmountField, HelpHint, HighlightedText, SelectionCard, SelectionGroup, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { AmountField, HelpHint, HighlightedText, SelectionCard, SelectionGroup, WizardSection }, script.__o.components);}